// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAQEByaOiu9PpBXE_NU2E4VcbhBYgpV8cQ",
  authDomain: "asan-dakar.firebaseapp.com",
  projectId: "asan-dakar",
  storageBucket: "asan-dakar.appspot.com",
  messagingSenderId: "641696759418",
  appId: "1:641696759418:web:f040a15e67086d24e345c3",
  measurementId: "G-JZRBST74VJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
